import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/site/ProtectedRoute";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CampaignBuilderPage from "./pages/CampaignBuilderPage";
import Geofencing101Page from "./pages/Geofencing101Page";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import CampaignDemoPage from "./pages/CampaignDemoPage";
import { PrivacyPolicyPage, TermsPage, CookiePolicyPage, DoNotSellPage } from "./pages/LegalPages";
import PaySuccessPage from "./pages/PaySuccessPage";
import PayCancelPage from "./pages/PayCancelPage";
import LoginPage from "./pages/LoginPage";
import PortalPage from "./pages/PortalPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 150);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "Rae Enterprise LLC | Luxury Geofencing & Programmatic Display Ads";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/apply" element={<Navigate to="/campaign-builder" replace />} />
            <Route path="/campaign-builder" element={<CampaignBuilderPage />} />
            <Route path="/geofencing-101" element={<Geofencing101Page />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/campaign-demo" element={<CampaignDemoPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/do-not-sell" element={<DoNotSellPage />} />
            <Route path="/pay/success" element={<PaySuccessPage />} />
            <Route path="/pay/cancel" element={<PayCancelPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <PortalPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#111111",
                color: "#ffffff",
                border: "1px solid rgba(212,175,55,0.3)",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
